import React from 'react';
import { SimpleGrid, Box } from '@chakra-ui/react';
import {
  Finance32,
  Star32,
  Portfolio32,
  Collaborate32,
} from '@carbon/icons-react';
import Section from '#coreComponents/Section';
import ServiceCard from '#coreComponents/ServiceCard';

const services = [
  {
    name: 'THE DataPoints: Data-driven strategic success',
    icon: Finance32,
    downloadUrl:
      'https://datapoints-static-files.s3.eu-west-1.amazonaws.com/files/the_datapoints.pdf',
  },
  {
    name: 'THE Branding Solutions: Global profile and visibility',
    icon: Star32,
    downloadUrl:
      'https://datapoints-static-files.s3.eu-west-1.amazonaws.com/files/the_branding_solutions.pdf',
  },
  {
    name: 'THE Hiring Solutions: Find the talent you need',
    icon: Portfolio32,
    downloadUrl:
      'https://datapoints-static-files.s3.eu-west-1.amazonaws.com/files/the_hiring_solutions.pdf',
  },
  {
    name: 'THE Consultancy Services: Strategy and expert guidance',
    icon: Collaborate32,
    downloadUrl:
      'https://datapoints-static-files.s3.eu-west-1.amazonaws.com/files/the_consultancy.pdf',
  },
];

const OtherServices = () => (
  <Section>
    <Box mb={6}>
      <Section.Title>Other Services</Section.Title>
    </Box>
    <SimpleGrid gridGap={6} rowGap={8} columns={{ base: 1, md: 3 }}>
      {services.map((serviceProps) => (
        <ServiceCard key={serviceProps.name} {...serviceProps} />
      ))}
    </SimpleGrid>
  </Section>
);

export default OtherServices;
